import { useQuery } from '@tanstack/react-query';
import {
  collection,
  getDocs,
  limit as limitFn,
  orderBy,
  query,
} from 'firebase/firestore';

import type { SecretAuditLog } from '@goenhub/shared';

import { db } from '@/lib/firebase';

export interface AuditLogRecord extends SecretAuditLog {
  id: string;
}

export function useSecretAuditLogs(limit = 100) {
  return useQuery({
    queryKey: ['secret_audit_logs', limit],
    queryFn: async (): Promise<AuditLogRecord[]> => {
      const q = query(
        collection(db, 'secret_audit_logs'),
        orderBy('timestamp', 'desc'),
        limitFn(limit),
      );
      const snap = await getDocs(q);
      return snap.docs.map((d) => ({ id: d.id, ...(d.data() as SecretAuditLog) }));
    },
  });
}
